import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Department } from '../models/department';

@Injectable({
  providedIn: 'root'
})
export class DepartmentService {
  apiEndpoint: string="";
  baseApiUrl: any;
  apiUniqueId: string = 'department/id/D32A6CC9-353B-4E23-90FB-3C410CD6FD7E';

  constructor(private httpService: HttpWrapperService, 
    private http: HttpClient,
    private configService: ConfigService) { 
      this.apiEndpoint = this.configService.getConfigValue("apiEndpoint");
      this.apiEndpoint += this.apiUniqueId;
    }
    getAllDepartment(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<any>>{ 
      return this.httpService.get(this.apiEndpoint + '/getAllDepartments?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                   
        if (result.Success && result.Success ) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
    
    GetAllDepartmentDetailsBySubdepartment(Department_Id:string): Observable<Array<any>>{ 
      return this.httpService.get(this.apiEndpoint + '/GetAllDepartmentDetailsBySubdepartment/' + (Department_Id ? Department_Id : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        if (result.Success && result.Success ) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
    viewDepartment(DepartmentID?: string): Observable<Array<Department>> {
      return this.httpService.get(this.apiEndpoint + '/viewDepartment/' + (DepartmentID ? DepartmentID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
    saveDepartment(departments: Department): Observable<any> { 
      return this.httpService.post(this.apiEndpoint + '/saveDepartment/', departments).pipe(map((result: any) => {
        if (result.Success) { 
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    deleteDepartment(DepartmentID?: string): Observable<any> {
      return this.httpService.post(this.apiEndpoint + '/deleteDepartment/' + (DepartmentID ? DepartmentID : '00000000-0000-0000-0000-000000000000'), DepartmentID).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    checkDuplication(DepartmentID?: string,Code?: string): Observable<any> {
      return this.httpService.get(this.apiEndpoint + '/checkDuplication?&DepartmentID=' + (DepartmentID ? DepartmentID : '00000000-0000-0000-0000-000000000000')+'&Code=' + (Code ? Code : '')).pipe(map((result: any) => {
          return result; 
      }));
    }

    checkEmail(Emailid?: string,DepartmentID?: string): Observable<any> {
      return this.httpService.get(this.apiEndpoint + '/checkEmail?Emailid=' + (Emailid ? Emailid : '')+ '&DepartmentID=' + (DepartmentID ? DepartmentID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
          return result; 
      }));
    }

  
  }

